import React from 'react';
import '../styles/Clients.css';

const Clients = () => {
  const clientSections = [
    {
      title: "Spare Parts Management",
      clients: [
        "Crompton (All India)",
        "Bajaj Electricals (Maharashtra & Goa)",
        "BSH Home Appliances"
      ]
    },
    {
      title: "Primary Transportation, LMD & C&F",
      clients: [
        "Onida, IFB, Godrej, Whirlpool, Nippon Paints",
        "Indigo Paints, Duroflex, Haier, LG, ISMT (Kirloskar Group)"
      ]
    },
    {
      title: "In-Plant & Warehouse",
      clients: [
        "Greaves Cotton Diesel, International Auto"
      ]
    }
  ];

  return (
    <section id="clients" className="clients">
      <div className="clients-container">
        <h2>Clients  Served</h2>
        {clientSections.map((section, index) => (
          <div key={index} className="client-section">
            <h3>{section.title}</h3>
            <div className="client-grid">
              {section.clients.map((client, i) => (
                <div key={i} className="client-card">
                  <p>{client}</p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Clients;
